import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SearchService } from '../../../core/tree/search/search.service';
import { SharedModule } from '../../../shared/shared.module';
import { OrderSearchService } from '../../order-search.service';

/** Component to provide CatalogueSearchService and destroy its instance when not needed */
@Component({
  selector: 'app-order-search-provider',
  templateUrl: './order-search-provider.component.html',
  providers: [OrderSearchService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, RouterOutlet],
})
export class OrderSearchProviderComponent implements OnInit, OnDestroy {
  private orderSearch = inject(OrderSearchService);
  private searchService = inject(SearchService);

  ngOnInit(): void {
    this.searchService.switchSearchService(this.orderSearch);
  }

  ngOnDestroy(): void {
    this.searchService.switchSearchService(null);
  }
}
